import { library } from '@fortawesome/fontawesome-svg-core';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import 'tippy.js/dist/tippy.css';
import App from './App';
import { KeycloakProvider } from './contexts/KeycloakContext';
import { GlobalStyles } from './styles';
import { LightTheme } from './styles/Themes';

library.add(fas, far);

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			retry: 0,
			refetchOnWindowFocus: false,
		},
	},
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
	<QueryClientProvider client={queryClient}>
		<ThemeProvider theme={LightTheme}>
			<Router>
				<KeycloakProvider>
					<GlobalStyles />
					<App />
				</KeycloakProvider>
			</Router>
		</ThemeProvider>
	</QueryClientProvider>
);
